import Button from 'ui/Button/Button';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import AboutBoardIcon from 'ui/SVG/AboutBoardIcon';
import './Works.scss';
import WorksMarquee from './WorksMarquee';

const Works: React.FC = () => {
  return (
    <div className="works centered" id="works">
      <WorksMarquee />
      <div className="works__container container">
        <ContentFrame className="works__frame" title="How It Works">
          <div className="works__content">
            <SectionTitle className="works__title">
              <span>how it works</span>
            </SectionTitle>
            <div className="works__wrapper">
              <AboutBoardIcon />
              <div>
                <p>
                  Streamers and gamers alike will be able to enjoy the experience of the
                  multiverse and earn for that. This is the centerpiece of what GETSETPLAY is
                  achieving.{' '}
                </p>
                <p>
                  There are areas within the ecosystem that even celebrates the fans and
                  streamers. The eSport stadium allows for games to be watched, Fan
                  appreciation zones where the ardent fans are celebrated.
                </p>
                <p>
                  With the token, holders can advance the goals of the GETSETPLAY DAO, and vote
                  on improvements and advances within the ecosystem.
                </p>
                <p>
                  With community marketing and peer to peer NFT marketplace marketing, the
                  GETSETPLAY ecosystem is a complete end-to-end interactive system within the
                  Multiverse.
                </p>
              </div>
            </div>
            <Button title="Start" to="#" className="works__btn" />
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Works;
